module.exports = __webpack_public_path__ + "img/W7019-full.2aefd24a.jpg";